










































import Vue from "vue";

export default Vue.extend({
    name: "CountdownButton",
    props: {
        label: {
            type: String,
            required: true
        },
        seconds: {
            type: Number,
            required: false,
            default: 10
        }
    },
    data: function() {
        return {
            secondsLeft: this.seconds as number,
            intervalId: null as number | null,
            triggered: false as boolean,
            radius: 11 as number,
            strokeWidth: 2 as number
        };
    },
    computed: {
        diameter: function(): number {
            return this.radius * 2 + this.strokeWidth;
        },
        center: function(): number {
            return this.diameter / 2;
        },
        circumference: function(): number {
            return this.radius * 2 * Math.PI;
        },
        dashOffset: function(): number {
            const elapsedFraction = 1 - this.secondsLeft / this.seconds;
            return this.circumference * elapsedFraction;
        }
    },
    mounted: function(): void {
        this.start();
    },
    beforeDestroy: function(): void {
        this.clear();
    },
    methods: {
        start: function(): void {
            this.clear();
            this.intervalId = window.setInterval(() => {
                if (this.secondsLeft <= 1) {
                    this.secondsLeft = 0;
                    this.clear();
                    this.handleTrigger();
                    return;
                }
                this.secondsLeft -= 1;
            }, 1000);
        },
        clear: function(): void {
            if (this.intervalId !== null) {
                window.clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },
        pause: function(): void {
            this.clear();
        },
        resume: function(): void {
            if (this.triggered || this.secondsLeft <= 0) {
                return;
            }
            if (this.intervalId === null) {
                this.start();
            }
        },
        handleTrigger: function(): void {
            if (this.triggered) {
                return;
            }
            this.triggered = true;
            this.clear();
            this.$emit("trigger");
        }
    }
});
